<template>
  <div class="articlemain">
    <com-returntop></com-returntop>
    <div class="header-img">
      <img
        src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download/banner.png"
        alt
      />
    </div>
    <!-- <div class="toobar">{{ title }}</div> -->
    <div class="wenzi">
      <div class="article-content" v-html="content"></div>
      <div v-if="attachment != ''" style="margin-bottom: 100px">
        附件下载：<a :href="attachment" download>{{ attachment_name }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import comReturntop from "@/components/returntop";
import { Article, timestampToTime } from "./../services/article";
export default {
  components: {
    comReturntop,
  },
  data() {
    return {
      content: "",
      title: "",
      id: 0, //文章id
      category_id: 0, //category_id
      attachment_name: "", //附件名称
      attachment: "", //附件地址
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getList(this.$route.query.id, this.$route.query.top);
  },
  methods: {
    getList(id, top) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      Article({
        id: id,
        top: top == null ? -1 : top,
      }).then((res) => {
        res.items.forEach((ele) => {
          if (ele.id == id) {
            this.content = ele.content;
            this.title = ele.name;
            if (ele.attachment != null) {
              this.attachment_name = ele.attachment_name;
              this.attachment = ele.attachment;
            }
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.wenzi {
  margin: 0px auto;
  width: 1000px;
  padding: 20px 26px;
  padding-top: 80px;
  background-color: #e8eff9;
  box-shadow: 0 0 2px #031A3C;
}
.articlemain {
  background: #ffffff;
}

.articlemain img {
  display: inline-block;
}

.articlemain .header-img {
  width: 100%;
  height: 237px;
}

.articlemain .header-img img {
  width: 100%;
  height: 100%;
}

.articlemain .middle {
  width: 100%;
  /* height: 680px; */
}

.articlemain .toobar {
  height: 90px;
  text-align: center;
  line-height: 90px;
  font-size: 34px;
  color: #333333;
  background-color: #e1e1e1;
}

.articlemain .middle img:hover {
  cursor: pointer;
}

.articlemain li {
  width: 100px;
  height: 80px;
  color: #fefefe;
  line-height: 80px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  display: list-item;
}

.articlemain li:hover {
  background: #0a57f4;
}

.article-content {
  font-size: 18px;
  margin-bottom: 100px;
  text-indent: 2em;
}

.article-content p > img {
  width: 1000px;
}
</style>
